import { componentQrl, inlinedQrl, useStore, useContextProvider, useTaskQrl, useLexicalScope, _jsxC, _IMMUTABLE, _fnSignal } from "@builder.io/qwik";
import builderContext from "../../../context/builder.context.qwik.mjs";
import { Block } from "../block.qwik.mjs";
const RepeatedBlock = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  const state = useStore({
    store: props.repeatContext
  });
  useContextProvider(builderContext, state.store);
  useTaskQrl(/* @__PURE__ */ inlinedQrl(({ track }) => {
    const [props2, state2] = useLexicalScope();
    track(() => props2.repeatContext);
    state2.store = props2.repeatContext;
  }, "RepeatedBlock_component_useTask_gy7uLKXBUbk", [
    props,
    state
  ]));
  return /* @__PURE__ */ _jsxC(Block, {
    get block() {
      return props.block;
    },
    get context() {
      return state.store;
    },
    get registeredComponents() {
      return props.registeredComponents;
    },
    get linkComponent() {
      return props.linkComponent;
    },
    [_IMMUTABLE]: {
      block: _fnSignal((p0) => p0.block, [
        props
      ], "p0.block"),
      context: _fnSignal((p0) => p0.store, [
        state
      ], "p0.store"),
      linkComponent: _fnSignal((p0) => p0.linkComponent, [
        props
      ], "p0.linkComponent"),
      registeredComponents: _fnSignal((p0) => p0.registeredComponents, [
        props
      ], "p0.registeredComponents")
    }
  }, 3, "GO_0");
}, "RepeatedBlock_component_JK1l2jKcfwA"));
export {
  RepeatedBlock,
  RepeatedBlock as default
};
